import { 
  GET_ENSAMBLADO,
  GET_ENSAMBLADOS,
  GET_ENSAMBLADOS_ALL,
  GET_ENSAMBLADOS_COUNT,
  ADD_ENSAMBLADO,
  DELETE_ENSAMBLADO,
  UPDATE_ENSAMBLADO,
  GET_FILTROS_ENSAMBLADOS } from "../action"

// ** Initial State
const initialState = {
  data: [],
  allData: [],
  selectedProducto: {},
  gruposAtributos: [],
  atributos: [],
  categorias: [],
  familias: [],
  ensamblados: [],
  selectedensambladoId: 1,
  params: {},
  processing: false,
  filtros: {}
}

const prefix = 'ensamblados'

const ensamblados = (state = initialState, action) => {
  switch (action.type) {
    case `${prefix}/GET_ALL_DATA`:
      return { ...state, allData: action.data }
      case GET_ENSAMBLADOS:
      return {
        ...state,
        data: action.ensamblados,
        total: action.total || 0,
        processing: false,
        params: action.params
      }
      case GET_ENSAMBLADOS_ALL:
      return {
          ...state,
          ensamblados: action.ensamblados,
          processing: false
      }
     case GET_ENSAMBLADO:
       return { ...state, selectedEnsamblado: action.selectedEnsamblado, ultimoIdEnsamblado: action.ultimoIdEnsamblado }
    case ADD_ENSAMBLADO:
      return { ...state, data: state.data.concat(action.data) }
    case DELETE_ENSAMBLADO:
      return { ...state, data: [...state.data].filter(ensamblado => ensamblado.id !== action.data)}
    case GET_ENSAMBLADOS_COUNT:
      return { ...state, total: action.total }
    case UPDATE_ENSAMBLADO:
      return { ...state, data: state.data.map(ensamblado => (ensamblado.id === action.data.id ? action.data : ensamblado)) }
    case GET_FILTROS_ENSAMBLADOS:
      return {
        ...state,
        filtros: action.filtros
      }
    default:
      return { ...state }
  }
}
export default ensamblados
